/* busy:
 *
 * Set busy mode during server interaction
 *
 * Author: Tim Bauwens
 * Copyright 2011, 2013, 2015 Berkeley Bridge
 *
 */

/* global jQuery */

import { bb } from "$json";
import { conf } from "$json/lib/conf";
import { pathOr } from "$json/lib/functional";

($ => {
  $(document).on(
    pathOr("bb:preStep", ["arbitrary", "busy", "on"], conf),
    function () {
      document.body.setAttribute("aria-busy", true);
      bb.Mode.set("busy");
    }
  );

  $(document).on(
    pathOr(
      "bb:postHandleData bb:jsonError",
      ["arbitrary", "busy", "off"],
      conf
    ),
    function () {
      document.body.setAttribute("aria-busy", false);
      bb.Mode.unset("busy");
    }
  );
})(jQuery);
